const translations = {
  titles: {
    warning: '! warning !',
    upgrade: '! Blocked !',
    contactInfo: 'Contact info detected!',

    // features.showRecurringNotifications
    congratulations: 'Congratulations',
  },
  messages: {
    userWarning: 'Our system has flagged and prevented the sharing of contact information with your chat partner. It is important to note that exchanging email addresses or phone numbers is not permitted on this platform. Ensure your privacy by adhering to our [guidelines].',
    userWarningCredits: 'Our system has flagged and prevented the sharing of contact information with your chat partner. It is important to note that exchanging email addresses or phone numbers is not permitted on this platform. Ensure your privacy by adhering to our [guidelines].',
    otherUserWarning: 'Our system has flagged and prevented the sharing of contact information with your chat partner. It is important to note that exchanging email addresses or phone numbers is not permitted on this platform. Ensure your privacy by adhering to our [guidelines].',
    upgrade: 'You used up all your free chats, [please upgrade your account] to continue chatting.',
    upgradeCredits: 'You have used up all of your free chats, [please buy credits] to continue chatting.',
    upgradeSexicons: 'You have used up all of your free sexicons, [please upgrade your account] to continue sending sexicons.',
    upgradeSexiconsCredits: 'You have used up all of your free sexicons, [please buy credits] to continue sending sexicons.',
    upgradeMessageCredits: 'You have used up all of your free chats, [please buy message credits] to continue chatting.',
    freeChat: 'You have used up your free message capacity. To chat with this user. [UPGRADE NOW]',
    freeChatCredits: 'You have used up all of your credits, to continue chatting with this user [Get More Credits Now!]',
    creditsPerMessage: 'Your Message ({creditsPerMessage} coins)',
    // DF only
    messageLimit: 'Maximum number of messages reached. You will be allowed to send new messages in 24 hours.',
  },
  // features.ageVerification
  ageVerification: {
    userWarningAgeVerification: 'An attempt to exchange contact info was detected and hidden from your chat partner. For security reasons we only allow %premium, verified members% to share their contact info with each other. [Please verify your account] to share such information',
    ageVerification: 'You used up all your free chats [click here to verify your age] for more chat credits.',
  },
  // features.showRecurringNotifications
  recurringNotification: {
    processing: 'Your request is being processed',
    default: 'Message not delivered! The chat feature is only available for VIP members or members with an ongoing subscription. Click [here] to re-enable your subscription to continue using the chat feature.',
    error: 'We couldn\'t enable your ongoing subscription, please [try again].',
    success: 'Your recurring membership has been re-enabled & chat functionality is fully reactivated to ensure continuous use of your membership!',
  },
  //features.imageUpload
  imageUpload: {
    premium: 'You need to be a premium member to upload images. [UPGRADE NOW]',
    premiumCredits: 'You need to be a premium member to upload images. [BUY CREDITS]',
    beta: 'This functionality is still in beta and is only limited to certain conversations',
    upgradeButton: 'Upgrade to see this image',
    unlockCreditsButton: 'Unlock credits to see this image',
    unlockButton: 'Unlock hottie\'s pic for only some credits!!',
    errorEntityTooLarge: 'File too big, please choose a smaller image',
    errorAllowedImageTypes: 'Only jpeg is allowed, please select another image',
    errorDefault: 'There was an error while uploading the image, please try again',
  },
  // features.virtualHottie
  virtualHottie: {
    virtualHottie: 'Virtual Hottie',
    chattingWithHottie: 'Hi, you are chatting with the virtual hottie',
    automatedProfile: 'I\'m an Automated Profile. For more information on Automated Profiles, please refer to the',
    termsAndConditions: 'Terms And Conditions',
  },
  // only "justNow" used when features.intl is enabled
  time: {
    justNow: 'just now',
    yesterday: 'yesterday',
    ago: 'ago',
  },
  basic: {
    // common
    typeAMessage: 'Type a message',
    textingNow: 'texting now',
    conversations: 'conversations',
    reveal: 'reveal',
    within1Mile: 'within 1 mile - ',
    withinXMiles: 'within {distance} miles - ',

    // optional
    send: 'Send', // if set to '' an icon will be used instead
    newMessage: '',
    unreadMessages: 'You have {count} unread messages!', // for demo purposes - actual key is "newMessage"
    noLocation: 'No location data',

    // vertical mode
    yearsOld: 'years old',

    // sidebar mode
    close: 'close',
    chats: 'chats', // either this or conversations can be removed

    // stickers enabled
    smileys: 'Smileys',
    stickers: 'Stickers',
    photo: 'Photo',
  },
};

['year', 'month', 'week', 'day', 'hour', 'minute', 'second'].forEach(interval => {
  translations.time[interval] = interval
  translations.time[interval + 's'] = interval + 's'
})

// Temporary code until migration is complete
const groupTranslations = newTranslations => {
  const mapping = {
    titles: ['warning', 'upgrade', 'contactInfo', 'congratulations'].map(t => `${t}Title`),
    messages: ['userWarning', 'otherUserWarning', 'upgrade', 'freeChat'],
    ageVerification: ['userWarningAgeVerification', 'ageVerification'],
    virtualHottie: ['virtualHottie', 'chattingWithHottie', 'automatedProfile', 'termsAndConditions'],
    recurringNotification: ['processing', 'default', 'error', 'success'].map(x => `recurringNotification_${x}`),
    time: ['justNow', 'yesterday', 'ago', 'year', 'years', 'month', 'months', 'week', 'weeks', 'day', 'days', 'hour', 'hours', 'minute', 'minutes', 'second', 'seconds'],
    basic: ['send', 'smileys', 'stickers', 'textingNow', 'typeAMessage', 'newMessage', 'close', 'chats', 'conversations', 'noLocation', 'yearsOld', 'reveal', 'within1Mile', 'withinXMiles'],
  }
  const groups = Object.entries(mapping).reduce((g, [key, value]) => ({ ...g, ...value.reduce((x, y) => ({ ...x, [y]: key }), {}) }), {})
  const flattenKey = (obj, key) => ({ ...obj, ...(typeof obj[key] === 'object' ? obj[key] : {}) })

  const result = { ...translations }
  Object.entries(flattenKey(newTranslations, 'time')).forEach(([key, value]) => {
    if (!groups[key] ) {
      return
    }
    const group = groups[key]
    const name = key.replace(/Title|recurringNotification_/, '').replace(/time(\w)/, (_, g1) => g1.toLowerCase())

    result[group][name] = value
  })
  return result
}

export const mapTranslations = ({ translations: groups, features: { ageVerification, intl } }) => {
  if (groups.upgradeTitle) {//client is using legacy translations setup
    groups = groupTranslations(groups)
  }
  if (ageVerification) {
    const av = groups.ageVerification
    groups.messages = {
      ...groups.messages,
      userWarning: av.userWarningAgeVerification,
      upgrade: av.ageVerification,
      freeChat: av.ageVerification,
    }
  }
  groups.time.rtf = intl && window?.Intl?.RelativeTimeFormat && new window.Intl.RelativeTimeFormat(intl, { numeric: 'auto' })
  CONFIG.translations = groups
  return groups
}

export default translations
